import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api';

export const getCampaignsForTimeline = createAsyncThunk('campaignsTimeline', async () => {
  const { data } = await axios.get('/campaigns/user-campaign-list');
  return data;
});

export const updateCampaignsTimeline = createAsyncThunk('updateCampaignsTimeline', async (payload: any, { rejectWithValue, dispatch }) => {
  try {
    await axios.post('/campaigns/update/timeline', payload);
    dispatch(getCampaignsForTimeline());
  } catch (error) {
    // @ts-ignore
    return rejectWithValue(error.response.data);
  }
});

export const clearCampaignsForTimeline = createAction('clearCampaignsForTimeline');